import { Handle, Position, useReactFlow } from "@xyflow/react";
import { BaseNode } from "@/components/base-node";
import { useTranslation } from "react-i18next";

type TriggerNodeData = { welcomeMessage?: string };

const TriggerNode = ({ id, data }: { id: string; data: TriggerNodeData }) => {
    const { setNodes } = useReactFlow();
    const welcomeMessage = data.welcomeMessage || "";
    const { t } = useTranslation();

    const onWelcomeMessageChange = (
        e: React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        setNodes((nodes) =>
            nodes.map((node) =>
                node.id === id
                    ? {
                          ...node,
                          data: {
                              ...node.data,
                              welcomeMessage: e.target.value,
                          },
                      }
                    : node
            )
        );
    };

    return (
        <BaseNode>
            <div className="p-4">
                <p className="font-bold">Trigger</p>
                <p className="text-xs text-gray-500 mb-2">
                    {t('triggerNodeDescription')}
                </p>
                <textarea
                    value={welcomeMessage}
                    onChange={onWelcomeMessageChange}
                    className="w-full rounded-md border border-gray-300 p-2"
                    placeholder="Optional: Enter a welcome message..."
                    rows={3}
                />
                {/* <div className="mt-2">
          <button
            onClick={() => {
              setEdges((eds: Edge[]) => eds.filter((e) => e.source !== id && e.target !== id));
              setNodes((nodes) => nodes.filter((n) => n.id !== id));
            }}
            className="text-red-600 px-2 py-1 text-sm border border-red-300 rounded"
          >
            Delete node
          </button>
        </div> */}
            </div>
            <Handle type="source" position={Position.Bottom} />
        </BaseNode>
    );
};

export default TriggerNode;
